module.exports = __webpack_public_path__ + "img/生气.bfcd2851.png";